/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
} from 'reactstrap';
import Select from 'react-select';
import Header from 'components/Headers/Header.js';
import {
  FaCheckCircle,
  FaEdit,
  FaPlusCircle,
  FaTimesCircle,
} from 'react-icons/fa';
import Swal from 'sweetalert2';
import api from 'services/api';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import modelConfiguradorPerfilAprovacao from 'models/ConfiguradorPerfilAprovacao';
import Perfil from 'models/Perfil';
import { ReportTemplate } from 'models/ReportTemplate';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import ProdutoModel from 'models/Produto';
import { PropostaStatus } from 'models/PropostaStatus';
import { iReport } from 'models/TemplateReport';
import { set } from 'date-fns';
import { Checkbox, FormControlLabel } from '@material-ui/core';

interface Option {
  readonly label: string;
  readonly value: string;
}

const ProdutoRelatorio: React.FC = () => {
  const [reportTemplateEditing, setReportTemplateEditing] = useState(
    {} as ReportTemplate,
  );
  const [listaProduto, setListaProduto] = useState([] as ProdutoModel[]);
  const [listaReportContent, setListaReportContent] = useState([] as iReport[]);
  const [mostrarInativos, setMostrarInativos] = useState(false);

  const [listaReportTemplate, setListaReportTemplate] = useState(
    [] as ReportTemplate[],
  );
  const [formModalState, setFormModalState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [produtoIdFiltrar, setProdutoIdFiltrar] = useState(0);

  async function carregarProdutos() {
    const response = await api.get('/produto');

    setListaProduto(response.data);
  }

  async function carregarReportTemplate() {
    const response = await api.get(
      `/impressao/produtoRelatorio/${produtoIdFiltrar}`,
    );

    console.log('response.data', response.data);

    setListaReportTemplate(response.data);
  }

  async function carregarReportContent() {
    const response = await api.get(`/impressao/reportContent`);

    setListaReportContent(response.data);
  }

  useEffect(() => {
    setIsLoading(true);
    carregarProdutos();
    carregarReportContent();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    console.log('reportTemplateEditing', reportTemplateEditing);
  }, [reportTemplateEditing]);

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        icon: 'info',
        text: `Buscando dados`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSaving) {
      Swal.fire({
        icon: 'info',
        text: `Salvando Registro`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });
    } else {
      Swal.close();
    }
  }, [isSaving]);

  useEffect(() => {
    setIsLoading(true);
    carregarReportTemplate();
    setIsLoading(false);
  }, [produtoIdFiltrar]);

  async function recarregarDados() {
    try {
      setIsLoading(true);
      await carregarProdutos();
      await carregarReportContent();
      await carregarReportTemplate(); // reload the table
    } finally {
      setIsLoading(false);
    }
  }

  async function handleDelete(itemId: number) {
    Swal.fire({
      title: `Deseja desativar o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      Swal.close();
      setIsSaving(true);
      if (result.isConfirmed) {
        await api.put(`/impressao/produtoRelatorio/${itemId}`, {
          isAtivo: false,
        });
        setIsSaving(false);
        toast.success('Registro desativado');
        recarregarDados();
      }
    });
  }

  async function handleAtivar(itemId: number) {
    Swal.fire({
      title: `Deseja reativar o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      Swal.close();
      setIsSaving(true);
      if (result.isConfirmed) {
        await api.put(`/impressao/produtoRelatorio/${itemId}`, {
          isAtivo: true,
        });
        setIsSaving(false);
        toast.success('Registro Reativado');
        recarregarDados();
      }
    });
  }

  async function handleInsert() {
    try {
      const params = {
        ...reportTemplateEditing,
        usarComponente: !reportTemplateEditing.conteudoId,
      };
      setIsSaving(true);
      const res = await api.post(`/impressao/produtoRelatorio`, params);
      console.log('handleInsert result', res.data);
      toast.success('Registro criado com sucesso!');
      setFormModalState(false); // close modal
      await recarregarDados(); // reload table
      setIsSaving(false);
    } catch (err) {
      console.error(err);
      toast.error('Erro ao criar registro');
    }
  }

  async function handleUpdate() {
    try {
      const params = {
        ...reportTemplateEditing,
        usarComponente: !reportTemplateEditing.conteudoId,
      };

      setIsSaving(true);
      await api.put(
        `/impressao/produtoRelatorio/${reportTemplateEditing.id}`,
        params,
      );
      toast.success('Registro atualizado com sucesso!');
      setFormModalState(false); // close modal
      await recarregarDados(); // reload table
    } catch (err) {
      console.error(err);
      toast.error('Erro ao atualizar registro');
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <>
      <Header showCards={false} />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  disabled={
                    !produtoIdFiltrar ||
                    !listaProduto.find(item => item.id === produtoIdFiltrar)
                  }
                  onClick={() => {
                    setReportTemplateEditing({
                      produtoId: produtoIdFiltrar,
                      produtoCategoriaId: listaProduto.find(
                        item => item.id === produtoIdFiltrar,
                      )?.produtoCategoriaId,
                      isAtivo: true,
                    } as ReportTemplate);
                    // then open the modal
                    setFormModalState(true);
                  }}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="lg"
              isOpen={formModalState}
              toggle={() => setFormModalState(!formModalState)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form">
                      <FormGroup className="mb-3" hidden>
                        <span>ID:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="ID"
                            type="number"
                            value={reportTemplateEditing.id}
                            onChange={text =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                id: Number(text.target.value),
                              })
                            }
                          >
                            {/* <option value="">Selecione...</option>
                            {listaMeioPagamento.map(item => {
                              return (
                                <option value={item.id}>
                                  {item.descricao}
                                </option>
                              );
                            })} */}
                          </Input>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <span>Nome*:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Nome"
                            type="text"
                            value={reportTemplateEditing.name}
                            onChange={text =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                name: text.target.value,
                              })
                            }
                          >
                            {/* <option value="">Selecione...</option>
                            {listaMeioPagamento.map(item => {
                              return (
                                <option value={item.id}>
                                  {item.descricao}
                                </option>
                              );
                            })} */}
                          </Input>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <span>Ordem*:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Ordem"
                            value={reportTemplateEditing.ordem ?? ''}
                            type="number"
                            onChange={text =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                ordem: Number(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <span>Componente:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="select"
                            value={reportTemplateEditing.componente ?? ''}
                            onChange={e =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                componente: e.target.value ?? '',
                              })
                            }
                          >
                            <option value="">Selecione...</option>
                            <option value="teste">teste</option>
                            <option value="MatrizResponsabilidade">
                              MatrizResponsabilidade
                            </option>
                            <option value="PropostaImpressaoOld">
                              PropostaImpressaoOld
                            </option>
                            <option value="FVImpressao">FVImpressao</option>
                            <option value="FVSimulacaoViabilidade">
                              FVSimulacaoViabilidade
                            </option>
                            <option value="CondicoesGeraisFornecimento">
                              CondicoesGeraisFornecimento
                            </option>
                            <option value="PedidoVenda">PedidoVenda</option>
                          </Input>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <span>Template:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Template"
                            type="select"
                            value={reportTemplateEditing.conteudoId ?? ''}
                            onChange={text =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                conteudoId: text.target.value
                                  ? Number(text.target.value)
                                  : null,
                              })
                            }
                          >
                            <option value="">Selecione...</option>
                            {listaReportContent.map(item => (
                              <option key={item.id} value={item.id}>
                                {item.nome}
                              </option>
                            ))}
                          </Input>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <span>Display Rule:</span>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Display Rule"
                            type="text"
                            value={reportTemplateEditing.displayRule ?? ''}
                            onChange={text =>
                              setReportTemplateEditing({
                                ...reportTemplateEditing,
                                displayRule: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          // disabled={isSaving}
                          onClick={async () => {
                            if (reportTemplateEditing.id) {
                              await handleUpdate();
                            } else {
                              await handleInsert();
                            }
                          }}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Produto x Relatórios</h3>
              </CardHeader>
              <Row>
                <Col sm="9" />
                <Col sm="3">
                  <FormControlLabel
                    className="float-right"
                    control={
                      <Checkbox
                        checked={mostrarInativos}
                        onChange={event =>
                          setMostrarInativos(event.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label="Mostrar Desativados"
                  />
                </Col>
              </Row>
              <CardBody>
                <Row>
                  <Col sm="12">
                    <small>
                      <strong>Produto:</strong>{' '}
                    </small>
                    <Input
                      placeholder="Produto"
                      type="select"
                      value={produtoIdFiltrar}
                      onChange={text =>
                        setProdutoIdFiltrar(Number(text.target.value))
                      }
                    >
                      <option value="">Selecione...</option>
                      {listaProduto.map(item => {
                        return <option value={item.id}>{item.nome}</option>;
                      })}
                    </Input>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col sm="12">
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th>Nome</th>
                          <th>Ordem</th>
                          <th>Componente</th>
                          <th>Template</th>
                          <th>Display Rule</th>
                          <th hidden={!mostrarInativos}>Ativo</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaReportTemplate
                          .filter(
                            item => mostrarInativos || item.isAtivo === true,
                          )
                          .map(item => (
                            <tr
                              key={item.id}
                              className={
                                item.isAtivo === true ? '' : 'text-muted'
                              }
                            >
                              <td className="py-2">{item?.name ?? ''}</td>
                              <td className="py-2">{item?.ordem ?? ''}</td>
                              <td className="py-2">{item.componente}</td>
                              <td className="py-2">
                                {listaReportContent.find(
                                  rc => rc.id === item.conteudoId,
                                )?.nome ?? ''}
                              </td>
                              <td className="py-2">{item.displayRule}</td>
                              <td className="py-2" hidden={!mostrarInativos}>
                                <div
                                  className={`badge badge-${
                                    item.isAtivo ? 'success' : 'danger'
                                  }`}
                                >
                                  {item.isAtivo ? 'Sim' : 'Não'}
                                </div>
                              </td>
                              <td className="py-2">
                                <div className="float-right">
                                  {item.isAtivo && (
                                    <>
                                      <Button
                                        size="sm"
                                        className="btn-icon"
                                        color="warning"
                                        type="button"
                                        onClick={() => {
                                          setReportTemplateEditing(item);
                                          setFormModalState(true);
                                        }}
                                      >
                                        <FaEdit />
                                      </Button>
                                      <Button
                                        size="sm"
                                        className="btn-icon"
                                        color="danger"
                                        type="button"
                                        onClick={() => {
                                          handleDelete(item.id);
                                        }}
                                      >
                                        <FaTimesCircle />
                                      </Button>
                                    </>
                                  )}
                                  {!item.isAtivo && (
                                    <>
                                      <Button
                                        size="sm"
                                        className="btn-icon"
                                        color="info"
                                        type="button"
                                        disabled={isSaving || isLoading}
                                        onClick={() => {
                                          handleAtivar(item.id);
                                        }}
                                      >
                                        <FaCheckCircle />
                                      </Button>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ProdutoRelatorio;
